import React, { useState, useContext } from "react";
import { ApiUrlContext } from "../App";
import { auth } from "../firebase";
import { sendPasswordResetEmail } from "firebase/auth";

export default function ForgotPassword() {
  const apiUrl = useContext(ApiUrlContext);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ loading: false, success: null, error: null });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: null, error: null });
    try {
      await fetch(`${apiUrl}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      // Use Firebase client SDK to send password reset email so Firebase uses the configured templates/SMTP
      const actionCodeSettings = {
        // Redirect back to the project's reset page after user clicks the email link
        url: process.env.REACT_APP_RESET_PASSWORD_REDIRECT || (window.location.origin + "/reset-password"),
        handleCodeInApp: true
      };
      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      setStatus({ loading: false, success: "Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.", error: null });
      setEmail("");
    } catch (err) {
      console.error("Firebase sendPasswordResetEmail error:", err);
      setStatus({ loading: false, success: null, error: "E-posta gönderilemedi. Lütfen adresinizi kontrol edin." });
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #e0e7ff 0%, #f7f7f7 100%)", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 370, background: "#fff", padding: "32px 20px", borderRadius: 18, boxShadow: "0 4px 24px #0002", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ fontSize: 32, fontWeight: 800, color: "#3b3b99", marginBottom: 8, letterSpacing: 1 }}>Şifremi Unuttum</div>
        <p style={{ color: "#444", fontSize: 15, marginBottom: 18, textAlign: "center" }}>
          Kayıtlı e-posta adresinizi girin. Şifre sıfırlama bağlantısı gönderilecektir.
        </p>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="E-posta adresiniz"
            style={{ width: "100%", padding: 10, borderRadius: 8, border: "1px solid #d1d5db", fontSize: 15, outline: "none", background: "#f5f7fa", marginBottom: 16 }}
          />
          <button
            type="submit"
            disabled={status.loading}
            style={{ width: "100%", padding: "12px 0", background: "linear-gradient(90deg, #6366f1 0%, #3b3b99 100%)", color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, fontSize: 17, letterSpacing: 1, marginTop: 4, boxShadow: "0 2px 8px #6366f122", cursor: "pointer", transition: "background 0.2s" }}
          >
            {status.loading ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
          </button>
        </form>
        {status.error && <div style={{ color: "#e53935", marginTop: 14, background: "#ffeaea", padding: "8px 12px", borderRadius: 6, fontSize: 14 }}>{status.error}</div>}
        {status.success && <div style={{ color: "#16a34a", marginTop: 14, background: "#eaffea", padding: "8px 12px", borderRadius: 6, fontSize: 14 }}>{status.success}</div>}
      </div>
    </div>
  );
}
